/**
 * The roster's controlled vocabularies, mirroring the server's list.
 *
 * Stored uppercase, so these are the literal stored values. `label` exists
 * only so the dropdowns are not shouting at the person filling the form.
 */
export const AGENT_DEPARTMENTS = [
  'SALES',
  'OPERATIONS',
  'SUPPORT',
  'MARKETING',
  'FINANCE',
  'LEGAL',
  'TECHNOLOGY',
  'HUMAN RESOURCES',
];

export const AGENT_DESIGNATIONS = [
  'INTERN',
  'AGENT',
  'SENIOR AGENT',
  'TEAM LEADER',
  'MANAGER',
  'REGIONAL MANAGER',
  'DIRECTOR',
];

/** "SENIOR AGENT" -> "Senior Agent", for display only. */
export function titleCase(value) {
  return String(value)
    .toLowerCase()
    .replace(/(^|\s)\S/g, (character) => character.toUpperCase());
}
